import * as React from 'react'
import { useSelector } from 'react-redux'
import { DownloadSimpleIcon } from '@phosphor-icons/react'
import { Server } from '../../../../../api/Server'
import { ScoopRow, ScoopColumn } from '../../../../ui/Layout'
import { ScoopText, ScoopButton, ScoopStatusBubble } from '../../../../ui'
import styles from './EmailDrawerInfo.module.scss'

export const EmailDrawerInfo = ({ logDetails }) => {
    const userID = useSelector((state) => state.auth.userID)
    const workspaceID = useSelector((state) => state.auth.workspaceID)
    const token = useSelector((state) => state.auth.token)

    const successSteps = [
        { step: 'Email received', status: 'Success' },
        { step: 'Data found in email', status: 'Success' },
        { step: 'Data successfully processed', status: 'Success' },
    ]

    const failureSteps = [
        { step: 'Email received', status: 'Success' },
        { step: "Couldn't scoop any data", status: 'Failed' },
    ]

    const processSourceContent = (result) => {
        const cleanedUrl = result?.url?.replace(/\s+/g, '')
        window.open(cleanedUrl)
    }

    const handleSourceContent = (inboxID, s3Key) => {
        const server = new Server(workspaceID, userID, token)
        server.postData(
            {
                action: 'getIngestionContent',
                inboxID: inboxID,
                s3Key: s3Key,
            },
            processSourceContent
        )
    }

    return (
        <>
            {logDetails.metadata && (
                <ScoopColumn>
                    <ScoopText className={styles.sectionTitle}>Source Info</ScoopText>

                    <ScoopRow className={styles.sourceInfoContainer}>
                        <ScoopColumn>
                            <ScoopRow className={styles.infoRow}>
                                <ScoopText className={styles.infoLabel}>Subject</ScoopText>
                                <ScoopText className={styles.infoValue}>
                                    {logDetails.metadata?.subject}
                                </ScoopText>
                            </ScoopRow>
                            <ScoopRow className={styles.infoRow}>
                                <ScoopText className={styles.infoLabel}>From</ScoopText>
                                <ScoopText className={styles.infoValue}>
                                    {logDetails.metadata?.from}
                                </ScoopText>
                            </ScoopRow>
                            <ScoopRow className={styles.infoRow}>
                                <ScoopText className={styles.infoLabel}>To</ScoopText>
                                <ScoopText className={styles.infoValue}>
                                    {logDetails.metadata?.to}
                                </ScoopText>
                            </ScoopRow>
                            {logDetails.metadata?.attachment && (
                                <ScoopRow className={styles.infoRow}>
                                    <ScoopText className={styles.infoLabel}>Attachment</ScoopText>
                                    <ScoopText className={styles.infoValue}>
                                        {logDetails.metadata?.attachment}
                                    </ScoopText>
                                </ScoopRow>
                            )}
                        </ScoopColumn>
                        <ScoopButton
                            variant="icon"
                            className={styles.downloadButton}
                            onClick={() => {
                                handleSourceContent(logDetails.inboxID, logDetails.s3key)
                            }}
                        >
                            <DownloadSimpleIcon size={20} />
                        </ScoopButton>
                    </ScoopRow>
                </ScoopColumn>
            )}
            <ScoopColumn>
                <ScoopText className={styles.sectionTitle}>Scoop Activity</ScoopText>
                {logDetails?.rstiKey ? (
                    successSteps?.map((step, index) => (
                        <React.Fragment key={index}>
                            <ScoopColumn>
                                <ScoopRow className={styles.activityStepContainer}>
                                    <ScoopStatusBubble status={step.status} />
                                    <ScoopText>{step.step}</ScoopText>
                                </ScoopRow>
                                {index !== successSteps?.length - 1 && (
                                    <div className={styles.connectorLine} />
                                )}
                            </ScoopColumn>
                        </React.Fragment>
                    ))
                ) : (
                    <>
                        {failureSteps?.map((step, index) => (
                            <React.Fragment key={index}>
                                <ScoopColumn>
                                    <ScoopRow className={styles.activityStepContainer}>
                                        <ScoopStatusBubble status={step.status} />
                                        <ScoopText>{step.step}</ScoopText>
                                    </ScoopRow>
                                    {index !== failureSteps?.length - 1 && (
                                        <div className={styles.connectorLine} />
                                    )}
                                </ScoopColumn>
                            </React.Fragment>
                        ))}
                        <div className={styles.errorMessageContainer}>
                            <ScoopText className={styles.errorMessageText}>
                                It looked like there was a bad condition, so we didn&apos;t load the
                                data to protect your snapshot data
                            </ScoopText>
                        </div>
                    </>
                )}
            </ScoopColumn>
        </>
    )
}
